export default "__VITE_ASSET__753899c2__"